import _classCallCheck from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { BaseSignerWalletAdapter, WalletConnectionError, WalletDisconnectionError, WalletError, WalletKeypairError, WalletNotConnectedError, WalletSignTransactionError, WalletWindowBlockedError, WalletWindowClosedError } from '@solana/wallet-adapter-base';
import { Keypair } from '@solana/web3.js';
import OpenLogin, { OPENLOGIN_NETWORK } from '@toruslabs/openlogin';
import { getED25519Key } from '@toruslabs/openlogin-ed25519';
export var TorusWalletAdapter = /*#__PURE__*/function (_BaseSignerWalletAdap) {
  _inherits(TorusWalletAdapter, _BaseSignerWalletAdap);

  var _super = _createSuper(TorusWalletAdapter);

  function TorusWalletAdapter(config) {
    var _this;

    _classCallCheck(this, TorusWalletAdapter);

    _this = _super.call(this);
    _this._options = Object.assign({
      uxMode: 'popup',
      network: OPENLOGIN_NETWORK.MAINNET
    }, config.options);
    _this._connecting = false;
    _this._openLogin = null;
    _this._keypair = null;
    return _this;
  }

  _createClass(TorusWalletAdapter, [{
    key: "publicKey",
    get: function get() {
      var _a;

      return ((_a = this._keypair) === null || _a === void 0 ? void 0 : _a.publicKey) || null;
    }
  }, {
    key: "ready",
    get: function get() {
      return typeof window !== 'undefined';
    }
  }, {
    key: "connecting",
    get: function get() {
      return this._connecting;
    }
  }, {
    key: "connected",
    get: function get() {
      return !!this._keypair;
    }
  }, {
    key: "connect",
    value: function connect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var openLogin, privateKey, listener, keypair;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(this.connected || this.connecting)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                this._connecting = true;
                _context.prev = 4;
                openLogin = new OpenLogin(this._options);
                _context.next = 8;
                return openLogin.init();

              case 8:
                privateKey = openLogin.privKey;

                if (privateKey) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 10;
                _context.next = 13;
                return new Promise(function (resolve, reject) {
                  listener = function listener(_ref) {
                    var reason = _ref.reason;

                    switch (reason === null || reason === void 0 ? void 0 : reason.message.toLowerCase()) {
                      case 'user closed popup':
                        reason = new WalletWindowClosedError(reason.message, reason);
                        break;

                      case 'unable to open window':
                        reason = new WalletWindowBlockedError(reason.message, reason);
                        break;
                    }

                    reject(reason);
                  };

                  window.addEventListener('unhandledrejection', listener);
                  openLogin.login().then( // HACK: result.privKey is not padded to 64 bytes, use provider.privKey
                  function (result) {
                    return resolve(openLogin.privKey);
                  }, function (reason) {
                    return listener({
                      reason: reason
                    });
                  });
                });

              case 13:
                privateKey = _context.sent;

              case 14:
                _context.prev = 14;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                window.removeEventListener('unhandledrejection', listener);
                return _context.finish(14);

              case 17:
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](4);

                if (!(_context.t0 instanceof WalletError)) {
                  _context.next = 23;
                  break;
                }

                throw _context.t0;

              case 23:
                throw new WalletConnectionError(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message, _context.t0);

              case 24:
                _context.prev = 24;
                keypair = Keypair.fromSecretKey(getED25519Key(privateKey).sk);
                _context.next = 31;
                break;

              case 28:
                _context.prev = 28;
                _context.t1 = _context["catch"](24);
                throw new WalletKeypairError(_context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.message, _context.t1);

              case 31:
                this._openLogin = openLogin;
                this._keypair = keypair;
                this.emit('connect');
                _context.next = 40;
                break;

              case 36:
                _context.prev = 36;
                _context.t2 = _context["catch"](0);
                this.emit('error', _context.t2);
                throw _context.t2;

              case 40:
                _context.prev = 40;
                this._connecting = false;
                return _context.finish(40);

              case 43:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 36, 40, 43], [4, 19], [10,, 14, 17], [24, 28]]);
      }));
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var openLogin;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                openLogin = this._openLogin;

                if (!openLogin) {
                  _context2.next = 14;
                  break;
                }

                this._openLogin = null;
                this._keypair = null;
                _context2.prev = 4;
                _context2.next = 7;
                return openLogin.logout();

              case 7:
                _context2.next = 9;
                return openLogin._cleanup();

              case 9:
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);
                this.emit('error', new WalletDisconnectionError(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message, _context2.t0));

              case 14:
                this.emit('disconnect');

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 11]]);
      }));
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(transaction) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var keypair;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                keypair = this._keypair;

                if (keypair) {
                  _context3.next = 4;
                  break;
                }

                throw new WalletNotConnectedError();

              case 4:
                _context3.prev = 4;
                transaction.partialSign(keypair);
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](4);
                throw new WalletSignTransactionError(_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message, _context3.t0);

              case 11:
                return _context3.abrupt("return", transaction);

              case 14:
                _context3.prev = 14;
                _context3.t1 = _context3["catch"](0);
                this.emit('error', _context3.t1);
                throw _context3.t1;

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 14], [4, 8]]);
      }));
    }
  }, {
    key: "signAllTransactions",
    value: function signAllTransactions(transactions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var keypair, _iterator, _step, transaction;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                keypair = this._keypair;

                if (keypair) {
                  _context4.next = 4;
                  break;
                }

                throw new WalletNotConnectedError();

              case 4:
                _context4.prev = 4;
                _iterator = _createForOfIteratorHelper(transactions);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    transaction = _step.value;
                    transaction.partialSign(keypair);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](4);
                throw new WalletSignTransactionError(_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.message, _context4.t0);

              case 12:
                return _context4.abrupt("return", transactions);

              case 15:
                _context4.prev = 15;
                _context4.t1 = _context4["catch"](0);
                this.emit('error', _context4.t1);
                throw _context4.t1;

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 15], [4, 9]]);
      }));
    }
  }]);

  return TorusWalletAdapter;
}(BaseSignerWalletAdapter);